import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  ActionSheetController,
  AlertController,
  LoadingController,
  Platform,
  ToastController
} from "ionic-angular";
import { EventsProvider } from "../../providers/events/events.provider";
import { UserProvider } from "../../providers/user/user.provider";
import { ChatPage } from "../chat/chat";
import { AuthProvider } from "../../providers/auth/auth.provider";
import { QrcodePage } from "../qrcode/qrcode";
import { TranslateService } from "@ngx-translate/core";
import { Camera } from "@ionic-native/camera";
import { MockupProvider } from "../../providers/mockup/mockup.provider";
import { AbonnementPage } from "../abonnement/abonnement";

/**
 * Generated class for the EventPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-event",
  templateUrl: "event.html"
})
export class EventPage {
  event: any;
  hasJoined = false;
  author: any;
  currentUser: any;
  want_to_join_event = true;
  cardSelectorModal: any;
  avatars = [];
  @ViewChild("file") fileInput: ElementRef;
  fileToUpload: File = null;
  picture: any = null;
  loading: any = null;
  i18n: string[] = [];

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private translate: TranslateService,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private camera: Camera,
    private platform: Platform,
    private mockupProvider: MockupProvider,
    public alertCtrl: AlertController,
    private eventsProvider: EventsProvider,
    private actionSheetCtrl: ActionSheetController,
    private authProvider: AuthProvider,
    private userProvider: UserProvider
  ) {
    this.event = this.navParams.get("event");
  }

  ionViewDidLoad() {
    // console.log("ionViewDidLoad EventPage");
    this.refreshLang();
    this.refresh();
  }



  refreshLang() {
    // console.log("refresh lang");
    this.translate
      .get([
        "PICTURE_ADDED_TO_GALLERY",
        "PICTURE_DOWNLOADED",
        "ERROR_SAVING_GALLERY",
        "EXPORT_IN_PROGRESS",
        "TITLE_ALERT_LEAVE",
        "MESSAGE_ALERT_LEAVE",
        "SAVE",
        "LEAVE_WITHOUT_SAVE",
        "SELECT_PICTURE",
        "OK",
        "YES",
        "NO",
        "CANCEL",
        "TITLE",
        "SUBTITLE",
        "DEMO_PICTURE",
        "LOAD_FROM_LIBRARY",
        "LOAD_FROM_COMPUTER",
        "USE_CAMERA"
      ])
      .subscribe(value => {
        this.i18n = value;
        // console.log("this.i18n",this.i18n);
      });
  }

  async refresh() {
    this.event = await this.eventsProvider.getEventById(this.event.id);
    // console.log("this.event",this.event);
  }


  goToChat() {
    this.navCtrl.push(ChatPage, { event: this.event });
  }

  presentAlertConfirm(){

    const confirm = this.alertCtrl.create({
      title: 'Hello Hello,',
      message: 'Tu vas confirmer que tu prends ta boisson chez ' + this.event.address.title + ". Présente le prochain écran au boarman pour qu'il valide ta boisson offerte 🍻😊",
      buttons: [
        {
          text: 'Annuler',
          handler: () => {
            console.log('Disagree clicked');
            this.navCtrl.push(AbonnementPage);

          }
        },
        {
          text: 'Valider',
          handler: () => {
            console.log('Agree clicked');
            this.navCtrl.push(QrcodePage,{bar:this.event});
          }
        }
      ]
    });
    confirm.present();
  }

  presentPictureActionSheet(){
    let button_library = {
      text: this.i18n["LOAD_FROM_LIBRARY"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    };
    let button_camera = {
      text: this.i18n["USE_CAMERA"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.CAMERA);
      }
    };
    let button_import_web = {
      text: this.i18n["LOAD_FROM_COMPUTER"],
      handler: () => {
        this.triggerFileInputClick();
      }
    };
    let button_cancel = {
      text: this.i18n["CANCEL"],
      role: "cancel"
    };
    let button_demo = {
      text: this.i18n["DEMO_PICTURE"],
      handler: () => {
        this.takeDemoPicture();
      }
    };
    let buttons = [button_demo, button_import_web, button_cancel];
    if (this.platform.is("cordova"))
      buttons = [button_demo, button_library, button_camera, button_cancel];

    let titletext = this.i18n["SELECT_PICTURE"];
    // console.log("titletext",titletext);
    let actionSheet = this.actionSheetCtrl.create({
      title: titletext,
      buttons: buttons
    });
    actionSheet.present();
  }

  triggerFileInputClick() {
    this.fileInput.nativeElement.click();
  }

  takeDemoPicture() {
    this.mockupProvider
      .getImageDemo()
      .then(dataUrl => {
        // console.log("takeDemoPicture success");
        return this.getPicture(dataUrl);
      })
      .then(picture => {
      })
      .catch(err => {
        console.error("error loading takeDemoPicture", err);
      });
  }
  
  async takePicture(sourceType) {
    var options = {
      quality: 100,
      sourceType: sourceType,
      targetWidth: 1024,
      targetHeight: 1024,
      destinationType: this.camera.DestinationType.DATA_URL,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };

    this.camera.getPicture(options).then(
      dataUrl => {
        // console.log("takePicture",dataUrl);
        this.getPicture(dataUrl)
          .then(picture => {
            // console.log("picture", picture);
          })
          .catch(err => {
            console.error("error loading takeDemoPicture", err);
          });
      },
      err => {
        this.presentToast("Error while selecting image.");
      }
    );
  }

  onFileInputChange(files: FileList) {
    this.fileToUpload = files.item(0);

    if (this.fileInput.nativeElement.value != "") {
      // console.log('onFileInputChange', this.fileInput.nativeElement.value);
      // console.log('this.fileToUpload', this.fileToUpload);
      this.fileToBase64(this.fileToUpload);
      // this.upload();
    }
  }
  fileToBase64(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // console.log(reader.result);
      let data = reader.result.toString();
      data = data.replace("data:image/png;base64,", "");
      data = data.replace("data:image/jpeg;base64,", "");
      data = data.replace("data:image/jpg;base64,", "");
      data = data.replace("data:image/webp;base64,", "");
      data = data.replace("data:image/gif;base64,", "");
      // console.log("file",file);
      // console.log("reader",reader);
      this.getPicture(data);
    };
    reader.onerror = error => {
      console.log("Error: ", error);
    };
  }

  async updateBar(){
    await this.eventsProvider.updateBar(this.event);
  }

  async getPicture(dataUrl) {
    let picture_name = new Date().getTime();
    let picture = {
      title: picture_name,
      contenu: "data:image/png;base64," + dataUrl
    };
    // console.log("getPicture",picture);
    this.event.picture = picture.contenu;
    this.updateBar();
  }

  presentLoading(content = "Please wait...") {
    this.loading = this.loadingCtrl.create({
      content: content
    });

    this.loading.present();
  }

  hideLoading() {
    this.loading.dismiss();
  }
  
  presentToast(message, duration = 3000) {
    // console.log('presentToast', message)
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: "middle",
      cssClass: "custom_toast"
    });

    toast.onDidDismiss(() => {
      console.log("Dismissed toast");
    });

    toast.present();
  }

  presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Options',
      buttons: [
        {
          text: "Signaler",
          role: "destructive",
          handler: () => {
            console.log("Destructive clicked");
          }
        },
        {
          text: "Ne plus participer",
          handler: () => {
            console.log("Archive clicked");
          }
        },
        {
          text: "Annuler",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        }
      ]
    });

    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/event.ts